export default __webpack_public_path__ + "static/media/camera.51a41e5a.svg";